import { PlaygroundProvider } from './context';
import Items from './Items';
import Nav from './Nav';

export default function Playground({ queries, mutations }) {
  const [firstItem] = queries;

  return (
    <PlaygroundProvider defaultSection={firstItem}>
      <div className="md:flex md:space-x-6">
        <div className="w-full md:w-1/3 md:flex-shrink-0">
          <h3 className="font-semibold text-xl leading-snug mb-6 text-white">
            See for yourself
          </h3>
          <div className="w-full md:flex md:space-x-6 space-y-6 md:space-y-0">
            <div className="w-full md:w-1/2">
              <Nav label="Queries" items={queries} />
            </div>
            <div className="w-full md:w-1/2">
              <Nav label="Mutations" items={mutations} />
            </div>
          </div>
        </div>
        <div className="w-full md:w-2/3 md:flex-shrink-0 pt-6 md:pt-0">
          <div className="bg-big-stone rounded border border-light-bunting flex-shrink-0 w-full">
            <Items items={[...queries, ...mutations]} />
          </div>
        </div>
      </div>
    </PlaygroundProvider>
  );
}
